var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle211(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.385,
    height: 282.385,
    viewBox: "0 0 282.385 282.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-211",
    transform: "matrix(0.438, 0.899, -0.899, 0.438, 189.809, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.591,
    cy: 105.591,
    rx: 105.591,
    ry: 105.591,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.591,
    cy: 105.591,
    rx: 105.091,
    ry: 105.091,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    transform: "translate(198.485 61.182)",
    fill: "#eaeaea",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 5.5,
    rx: 5.5,
    ry: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 5.5,
    rx: 5,
    ry: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(61.578 7.983)",
    fill: "#eaeaea",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.773,
    cy: 3.773,
    rx: 3.773,
    ry: 3.773,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.773,
    cy: 3.773,
    rx: 3.273,
    ry: 3.273,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    transform: "translate(161.925 184.565)",
    fill: "#eaeaea",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 5.5,
    rx: 5.5,
    ry: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 5.5,
    rx: 5,
    ry: 5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle211);
export default __webpack_public_path__ + "static/media/circle-211.55f2fe2d0850b79348fd8394f06977c6.svg";
export { ForwardRef as ReactComponent };